<!--
  Plugin:
  https://github.com/xlsdg/vue-countup-v2
  it includes vue-countup (v1)
  DEMO: https://inorganik.github.io/countUp.js/
-->


<template>
  <span class="iCountUp">
    <ICountUp
      :delay="delay"
      :endVal="endVal"
      :options="options"
      @ready="onReady"
    />
  </span>
</template>

<script type="text/babel">
import ICountUp from 'vue-countup-v2';

export default {
  name: 'counter',
  props: ['countTo'],
  components: {
    ICountUp,
  },
  data() {
    return {
      delay: 1500,
      endVal: this.$props.countTo,
      options: {
        duration: 5,
        useEasing: true,
        useGrouping: true,
        decimalPlaces: 0,
        separator: '.',
        decimal: ',',
        prefix: '',
        suffix: '',
      },
    };
  },
  methods: {
    onReady(instance) {
      const that = this;
      instance.update(that.endVal);
    },
  },
};
</script>

<style scoped>

</style>
